import ApiService, { SUFRow } from "../../services/ApiService";
import { AxiosResponse } from "axios";

export interface RosterTestTaker {
    state: string
    districtName: string
    districtCode: string
    schoolName: string
    schoolCode: string
    firstName: string
    lastName: string
    grade: string
    gender: string
    dateOfBirth: string 
    language: string
    oppCode: string
    sfId: string
    stateId: string
    productPackage: string
    testingGroupName: string
  openDate: string | number 
  closeDate: string | number 
  error: string | null
}
export interface CSVResult {
    sufRows: SUFRow[]
    rosterTesttakers: RosterTestTaker[]
    state: string
    districtOrCustomer: string
    oppCode: string
    productPackage: string
    tabNum?: number
    success: boolean
    error: string | null 
    productId: number
    teacherEmail?: string | null
}

export default class RosterService {

    static uploadAndValidateCSV(file: File): Promise<CSVResult[]> {
        const url: string = `${ApiService.API_URL}codegen/validate-and-check-suf-csv`;
        return ApiService.addInteractionBlockingRequest(ApiService.postFile(url, file))
          .then((response: AxiosResponse) => response.data as CSVResult[]);
      }

      static submitSUFToCreateCodesAndRoster(groups: CSVResult[]): Promise<CSVResult[]> {
        const url: string = `${ApiService.API_URL}codegen/create-codes-and-roster`;
        return ApiService.addInteractionBlockingRequest(ApiService.post(url, groups))
          .then((response: AxiosResponse) => response.data as CSVResult[]);
      }
}